import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="protection-title" data-id="element-194" data-mp="20m4opq90saty">
      <div className="mx-auto max-w-3xl rounded-3xl bg-success-soft p-6 ring-1 ring-success/20 sm:p-10" data-id="element-195" data-mp="24lnd4w01v41j">
        <div className="flex flex-col items-center text-center" data-id="element-196" data-mp="29f7zfqsa69kw">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-success text-white" data-id="element-197" data-mp="2edt4c3ih9hfo">
            <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-198" data-mp="2jb1ilt0i91bn" />
          </span>
          <p className="mt-4 text-sm font-bold uppercase tracking-wide text-success" data-id="element-199" data-mp="2oaxro6o27iy2">Your purchase protection</p>
          <h2 id="protection-title" className="mt-2 font-display text-[26px] font-black leading-tight text-ink sm:text-3xl" data-id="element-200" data-mp="2sbrawmqk49km">
            Explore the Blueprint With Confidence
          </h2>
        </div>
        <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-201" data-mp="xzjcgzf11ak3">
          <p data-id="element-202" data-mp="3slol54ewsa80">I want you to understand exactly what you're purchasing.</p>
          <p data-id="element-203" data-mp="3nuzwrxyiztd3">
            The Mandibular Complete Denture Blueprint™ is a digital educational resource designed to help dental
            professionals organize clinical assessments and treatment planning considerations.
          </p>
          <p data-id="element-204" data-mp="3dxlfxx8ox2k9">
            You'll receive the six-volume collection, five professional bonuses, and accompanying clinical tools
            described above.
          </p>
          <p className="rounded-xl bg-white p-4 text-base" data-id="element-205" data-mp="ag3ce1zyahpn">
            <strong data-id="element-206" data-mp="adqu1nqa65c2">Refund policy:</strong> please review the final refund terms and request procedure displayed at
            checkout before purchasing.
          </p>
        </div>
      </div>

      <SectionCta label="Yes! I want to explore the Blueprint today" data-id="element-207" data-mp="he3gyq187lj" />
    </section>;
}